import { GiftCardResponse } from "api";
import {
    createContext, Dispatch, FC, SetStateAction, useContext, useState
} from "react";



export type GiftCardContextType = {
    setGiftCard: Dispatch<SetStateAction<{}>>
    giftCard: GiftCardResponse
}

export const GiftCardContext = createContext<GiftCardContextType>(null)


export const GiftCardContextProvider: FC = ({ children }) => {

    const [giftCard, setGiftCard] = useState(null);

    return (
        <GiftCardContext.Provider
            value={{
                giftCard,
                setGiftCard,
            }}
        >
            {children}
        </GiftCardContext.Provider>
    )

}

export const useGiftCardContext = () => useContext(GiftCardContext)
